import type { SxProps, Theme } from '@mui/material';

export const styles = {
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
    } as SxProps<Theme>,
    titleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        flexShrink: 0,
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    title: {
        display: 'flex',
        alignItems: 'center',
        fontSize: { xs: '22px', md: '28px' },
    } as SxProps<Theme>,
    content: {
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    } as SxProps<Theme>,
};
